import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {CampaignsService} from 'src/app/core/services/api/campaigns.service';
import {finalize, take} from 'rxjs/operators';
import { Swal2 } from 'src/app/core/utils/swal2.util';
import {AsignarVocerosClienteFormComponent} from '../form/asignar-voceros-cliente-form.component';
import {BehaviorSubject} from 'rxjs';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { SpokesmenService } from 'src/app/core/services/api/spokesmen.service';

@Component({
    selector: 'app-asignar-voceros-cliente-list',
    templateUrl: './asignar-voceros-cliente-list.component.html',
    styleUrls: ['./asignar-voceros-cliente-list.component.scss']
})
export class AsignarVocerosClienteListComponent implements OnInit {

    @Input() id: any;
    @Input() idCliente: any;
    rows: any[] = [];
    loading = true;
    messages = {emptyMessage: 'No hay información para mostrar.'};

    list = new BehaviorSubject<any>([]);
    list$ = this.list.asObservable();

    addPermission = this.auth.isPermit('cliente.vocero.add');
    editPermission = this.auth.isPermit('cliente.vocero.edit');
    deletePermission = this.auth.isPermit('cliente.vocero.delete');

    constructor(
        public dialog: MatDialog,
        private spokesmenService: SpokesmenService,
        private auth: AuthService,
        private swal: Swal2
    ) {
    }

    ngOnInit(): void {
        this.getAll();
    }

    getAll() {
        this.loading = true;
        this.spokesmenService.getListByCliente(this.idCliente).pipe(finalize(() => this.loading = false)).subscribe((response:any) => {
            const clienteVoceros = response.data;
            this.rows = clienteVoceros
            this.list.next(clienteVoceros)
        })
    }

    add() {
        this.openDialog();
    }

    edit(row: any) {
        this.openDialog(row);
    }

    openDialog(row?: any) {
        const dialogRef = this.dialog.open(AsignarVocerosClienteFormComponent, {
            data: {row, id: Number(this.id), idCliente: this.idCliente},
            width: '800px'
        });

        dialogRef.afterClosed().pipe(take(1)).subscribe(result => {
            if (result) {
                this.getAll();
            }
        });
    }

    delete(id: number) {
        this.swal.deleteItem().then(val => {
            if (val) {
                this.spokesmenService.deleteClienteVoceros(id)
                .subscribe(
                    (response:any) => {
                        this.getAll()
                        this.swal.showTitleAlert('Eliminado',response.message,'success')
                    },
                    error => {
                        this.swal.showErrorAlert(error.error.message)
                    }
                )
            }
        });
    }
}
